import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Link, Text } from '@chakra-ui/react';
import { FORM_BUTTON_TYPES, FORM_FIELD_TYPES, FORM_VALIDATIONS } from '@whitbread-eos/atoms';
import { formatDataTestId } from '@whitbread-eos/utils';
import * as yup from 'yup';
import { jsx as _jsx } from "react/jsx-runtime";
export var loginFormConfig = _ref => {
  var _labels$login, _labels$login2, _labels$login3, _labels$login4, _labels$login5, _labels$login6, _labels$login7, _labels$login8;
  var getTypographyProps = _ref.getTypographyProps,
    getFormState = _ref.getFormState,
    defaultValues = _ref.defaultValues,
    defaultErrors = _ref.defaultErrors,
    onSubmit = _ref.onSubmit,
    handleResetPass = _ref.handleResetPass,
    baseDataTestId = _ref.baseDataTestId,
    extraStyles = _ref.extraStyles,
    buttonsContainerStyles = _ref.buttonsContainerStyles,
    resetForm = _ref.resetForm,
    fieldProps = _ref.fieldProps,
    labels = _ref.labels;
  var loginFormValidationSchema = yup.object().shape({
    email: yup.string().required((labels === null || labels === void 0 || (_labels$login = labels.login) === null || _labels$login === void 0 || (_labels$login = _labels$login.business) === null || _labels$login === void 0 ? void 0 : _labels$login.bookingLoginRequiredText) || (labels === null || labels === void 0 || (_labels$login2 = labels.login) === null || _labels$login2 === void 0 ? void 0 : _labels$login2.invalidEmail)).matches(FORM_VALIDATIONS.EMAIL.MATCHES, (labels === null || labels === void 0 || (_labels$login3 = labels.login) === null || _labels$login3 === void 0 || (_labels$login3 = _labels$login3.business) === null || _labels$login3 === void 0 ? void 0 : _labels$login3.bookingsInvalidEmailMsg) || (labels === null || labels === void 0 || (_labels$login4 = labels.login) === null || _labels$login4 === void 0 ? void 0 : _labels$login4.invalidEmail)).max(FORM_VALIDATIONS.EMAIL.MAX, (labels === null || labels === void 0 || (_labels$login5 = labels.login) === null || _labels$login5 === void 0 || (_labels$login5 = _labels$login5.business) === null || _labels$login5 === void 0 ? void 0 : _labels$login5.bookingEmailMaxLengthMsg) || (labels === null || labels === void 0 || (_labels$login6 = labels.login) === null || _labels$login6 === void 0 ? void 0 : _labels$login6.invalidEmail)),
    password: yup.string().required((labels === null || labels === void 0 || (_labels$login7 = labels.login) === null || _labels$login7 === void 0 || (_labels$login7 = _labels$login7.business) === null || _labels$login7 === void 0 ? void 0 : _labels$login7.bookingLoginRequiredText) || (labels === null || labels === void 0 || (_labels$login8 = labels.login) === null || _labels$login8 === void 0 ? void 0 : _labels$login8.badCredentialsError))
  });
  var _fieldProps$hideForgo = fieldProps.hideForgottenPassword,
    hideForgottenPassword = _fieldProps$hideForgo === void 0 ? false : _fieldProps$hideForgo;
  var inputFieldStyles = {
    inputElementStyles: _objectSpread(_objectSpread({}, getTypographyProps({}, inputFieldSemanticTypography)), placeholderStyles)
  };
  var forgottenPasswordLinkTypographyStyles = getTypographyProps({}, forgottenPasswordLinkSemanticTypography);
  var loginButtonTypographyStyles = getTypographyProps({}, loginButtonSemanticTypography);
  var config = {
    elements: {
      buttonsContainerStyles,
      fields: [{
        type: FORM_FIELD_TYPES.INPUT_EMAIL,
        name: 'email',
        label: labels.login.leisure.emailPlaceholder,
        props: _objectSpread(_objectSpread({}, fieldProps), {}, {
          styles: inputFieldStyles
        }),
        styles: {
          marginBottom: 'lg'
        },
        testid: formatDataTestId(baseDataTestId, 'Email')
      }, {
        type: FORM_FIELD_TYPES.INPUT_PASSWORD,
        name: 'password',
        label: labels.login.passwordPlaceholder,
        props: _objectSpread(_objectSpread({}, fieldProps), {}, {
          styles: inputFieldStyles
        }),
        testid: formatDataTestId(baseDataTestId, 'Password')
      }, {
        type: FORM_FIELD_TYPES.NON_FIELD_CONTENT,
        name: 'forgottenPassLink',
        hidden: hideForgottenPassword,
        content: _jsx(Link, _objectSpread(_objectSpread({}, extraStyles), {}, {
          textDecoration: "underline",
          display: "block",
          mb: "md",
          "data-testid": formatDataTestId(baseDataTestId, 'ResetPassLink'),
          onClick: handleResetPass,
          children: _jsx(Text, _objectSpread(_objectSpread({
            as: "span"
          }, forgottenPasswordLinkTypographyStyles), {}, {
            children: labels.login.forgotPassword
          }))
        }))
      }],
      buttons: [{
        type: FORM_BUTTON_TYPES.SUBMIT,
        label: labels.login.leisure.loginButton,
        action: onSubmit,
        props: _objectSpread({
          variant: 'login',
          size: 'full'
        }, loginButtonTypographyStyles),
        testid: formatDataTestId(baseDataTestId, 'ButtonLogin')
      }]
    },
    defaultValues,
    validationSchema: loginFormValidationSchema,
    getFormState,
    defaultErrors,
    resetForm
  };
  return config;
};
var placeholderStyles = {
  _placeholder: {
    fontStyle: 'normal',
    color: 'var(--chakra-colors-chakra-subtle-text)'
  }
};
var inputFieldSemanticTypography = {
  textStyle: 'body-m-regular'
};
var forgottenPasswordLinkSemanticTypography = {
  textStyle: 'link-m-regular'
};
var loginButtonSemanticTypography = {
  textStyle: 'label-xl'
};